// extracted by mini-css-extract-plugin
export var divider = "_ef-7";
export var itemsToggle = "_ef-8";
export var mergeModal = "_ef-1";
export var optionCard = "_ef-4";
export var radioGroup = "_ef-6";
export var radioOption = "_ef-0";
export var selected = "_ef-5";
export var shipmentOptions = "_ef-2";
export var tableOptions = "_ef-3";